<template>
  <section class="section-container" v-if="is_supplier || is_administrator">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('units.title') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <search @make_search="make_search"/>
                <table class="table table-striped dataTable my-4 w-100" id="units">
                  <thead>
                  <tr>
                    <th>
                      <order-by name="code" :ordering="ordering" @order="order">
                        {{ $t('units.code') }}
                      </order-by>
                    </th>
                    <th>
                      <order-by name="name" :ordering="ordering" @order="order">
                        {{ $t('units.name') }}
                      </order-by>
                    </th>
                    <th>
                      <order-by name="is_active" :ordering="ordering" @order="order">
                        {{ $t('units.state') }}
                      </order-by>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="row.id" class="gradeX" v-for="row in rows">
                    <td>{{ row.code }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.is_active ? $t('units.status.active') : $t('units.status.disabled') }}</td>
                  </tr>
                  </tbody>
                </table>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import message from '@/message'
import Search from '@/components/Search.vue'
import OrderBy from "@/components/OrderBy";
import Pagination from '@/components/Pagination.vue'
import Contentheading from '@/components/Contentheading.vue'

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'name'
  const page = parseInt(route.query.page) || 1

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
    || {}
  let page_size = route.query.page_size
    || stored_page_size[route.name]
    || process.env.DEFAULT_PAGE_SIZE

  api.get('/units/', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size
    }
  })
    .then(resp => {
      let rows = resp.data.results
      next({
        rows: rows,
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: rows.length,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    pagination: Pagination,
    search: Search,
    orderBy: OrderBy
  },
  data() {
    return {
      rows: [],
      selected: [],
      page: null,
      pages: null,
      count: null,
      search: null,
      ordering: null,
      page_size: null,
    }
  },
  computed: {
    is_supplier() {
      return this.$store.getters.user_group === 'Supplier'
    },
    is_administrator() {
      return this.$store.getters.user_group === 'Administrator'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  mounted() {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'units'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    remove_unit(id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('units.are-you-sure'),
        text: this.$i18n.t('units.are-you-sure-text-cancel'),
        showCancelButton: true
      })
        .then((choice) => {
          if (choice.value) {
            api.patch(`/units/${id}/`, {is_deleted: true, is_active: false})
              .then(() => {
                message.success(this.$i18n.t('units.deleted'))
                this.$delete(this.rows, index)
              })
              .catch(() => {
                message.error(this.$i18n.t('units.forbidden'))
              })
          }
        })
    },
    order(o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate(p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search() {
      this.$parent.make_search(this.search, this.ordering)
    },
    updateStatus(e) {
      let id = e.target.value
      api.patch(`/units/${id}`, {
        id: id,
        is_active: e.target.checked
      }).catch(error => {
        console.error(error)
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>

<style scoped>
.content-heading {
  height: 74px
}
</style>



// WEBPACK FOOTER //
// src/views/Units.vue